module.exports = __webpack_public_path__ + "img/matrix-manipulator-0.8ee73e42.png";